/**
 * Wenn das Objekt fieldName im Objekt toChange vorhanden ist,
 * wird toChange[fieldName] zum Wert, welcher unter innerFieldName im entsprechenden Objekt gespeichert ist
 * @param toChange
 * @param fieldName
 * @param innerFieldName
 */
export function changeFieldValueIfPresent(toChange, fieldName, innerFieldName) {
    if (!toChange[fieldName]) {
        return;
    }
    toChange[fieldName] = toChange[fieldName][innerFieldName];
}

export function removeEmptyValues(obj) {
    Object.keys(obj).forEach((key) => (obj[key] == null || obj[key] === "") && delete obj[key]);
}
